import { ICounterTable } from "../../interfaces/CounterTable";
import { IInventTable } from "../../interfaces/InventTable";
import { IPrintTable } from "../../interfaces/PrintTable";

interface MainState {
  invent: IInventTable[];
  counterData: ICounterTable[];
  printData: IPrintTable[];
}

export const initialState: MainState = {
  invent: [],
  counterData: [],
  printData: [],
};

export interface MainAction {
  type:
    | typeof SET_INVENT_DATA
    | typeof SET_COUNTER_DATA
    | typeof SET_PRINT_DATA
    | typeof DATA_LOGOUT;
    invent?: IInventTable[];
    counterData?: ICounterTable[];
    printData?: IPrintTable[];
}

const CompanyDataReducer = (state: MainState = initialState, action: MainAction): MainState => {
  switch (action.type) {
    case SET_INVENT_DATA:
      return {
        ...state,
        invent: action.invent || [],
      };
    case SET_COUNTER_DATA:
      return {
        ...state,
        counterData: action.counterData || [],
      };
    case SET_PRINT_DATA:
      return {
        ...state,
        printData: action.printData || [],
      };
    case DATA_LOGOUT:
        return initialState;
    default:
      return state;
  }
};


export const SET_INVENT_DATA = "SET_INVENT_DATA";
export const SET_COUNTER_DATA = "SET_COUNTER_DATA";
export const DATA_LOGOUT = "DATA_LOGOUT";
export const SET_PRINT_DATA = "SET_PRINT_DATA";

export default CompanyDataReducer;
